export var API_DEFAULT_DOMAIN = 'api.alwayson.ai';
export var MESSAGE_TYPE_CATEGORY = 'category';
export var MESSAGE_TYPE_TEXT = 'text';
export var MESSAGE_TYPE_HTML = 'html';
export var MESSAGE_TYPE_WELCOME = 'welcome';
export var MESSAGE_TYPE_CONTACT_FORM = 'contact_form';
export var MESSAGE_TYPE_NOT_FOUND_OPTIONS = 'not_found_options';
export var MESSAGE_TYPE_WEBSEARCH = 'websearch';
export var MESSAGE_TYPE_WEBSEARCH_WITH_ORIGINAL_QUESTION = 'websearch_with_original_question';
export var ANSWER_REPORT_NOT_RELEVANT = 'not_relevant';
export var ANSWER_REPORT_INCORRECT_INFO = 'incorrect_info';
export var ANSWER_REPORT_OUTDATED = 'outdated';
export var ANSWER_FEEDBACK_TYPE_INFORMATION_NEEDED = 'information_needed';
export var ANSWER_FEEDBACK_TYPE_ANSWER_WAS_HELPFUL = 'answer_was_helpful';
